import type { Router } from 'vue-router'
import { initRouter } from './router'
import useAppStore from '@/store/app'
import { ccLog } from 'common/utils/log'
import { setFirebaseUser } from 'common/utils/firebase/utils'
import { getOrdernumber } from 'common/utils/cookies'

export const whiteList = ['/expired', '/success', 'mpesaError', '/mpesaSuccess']
const getInterceptorRouter = (router: Router) => {
  initRouter(router)
  router.beforeEach((to, from) => {
    const { path, query } = to
    const { token, ordernumber } = query

    if (whiteList.includes(path)) {
      if (!ordernumber && getOrdernumber()) {
        return {
          path: path,
          query: { ...query, ordernumber: getOrdernumber() },
        }
      } else {
        return true
      }
    } else {
      if (token) {
        setFirebaseUser({ ordernumber: `${ordernumber}` })
        ccLog(token as string)
        return true
      } else {
        return { name: 'expired', replace: true }
      }
    }
  })

  router.afterEach((to) => {
    const { token, language, ordernumber } = to.query
    const appStore = useAppStore()
    appStore.init(token as string, language as string, ordernumber as string)
  })

  return router
}

export default { getInterceptorRouter }
